<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <EventHeader :event="event" />
      <CardComponent>
        <span class="title"
          >Manage Heats - {{ adding ? 'New Workout' : workout.name }}</span
        >
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <form class="has-margin-top-30" @submit.prevent="passes(submit)">
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="control">
                  <BaseInput
                    v-model="workout.name"
                    label="Workout Name"
                    rules="required"
                  />
                </div>
              </div>
              <div class="column is-6">
                <div class="control">
                  <BaseDateTimePicker
                    v-model="workout.startdate"
                    label="Start Date and Time"
                    rules="required"
                  />
                </div>
              </div>
            </div>
            <div class="has-text-centered">
              <div class="is-block has-margin-bottom-15">
                <b-button
                  v-if="!adding"
                  class="has-margin-right-10"
                  icon-left="arrow-left"
                  size="is-medium"
                  tag="router-link"
                  :to="{
                    name: 'ManageDivisions',
                    params: {
                      eventid: $route.params.eventid
                    }
                  }"
                >
                  Manage Divisions</b-button
                >
                <b-button
                  :disabled="loading"
                  type="is-primary"
                  size="is-medium"
                  @click="passes(submit)"
                >
                  {{ adding ? 'Create' : 'Update' }}</b-button
                >
              </div>
            </div>
          </form>
        </ValidationObserver>
        <div v-for="heat in heats" :key="heat.id">
          Heat {{ heat.number }} - {{ heat.startdate }}
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventHeader from '@/components/EventHeader'
import CardComponent from '@/components/CardComponent'
import BaseInput from '@/components/BaseInput'
import BaseDateTimePicker from '@/components/BaseDateTimePicker'
import Filters from '@/mixins/filters'
import HeatWorkoutApi from '@/api/heat-workout'
import HeatWorkoutHeatApi from '@/api/heat-workout-heat'

export default {
  name: 'ManageHeats',
  components: {
    CardComponent,
    EventHeader,
    BaseInput,
    BaseDateTimePicker
  },
  mixins: [Filters],
  data() {
    return {
      adding: this.$route.name === 'AddHeatWorkout',
      workout: {},
      heats: [],
      search: '',
      initialized: false
    }
  },
  computed: {
    ...mapGetters(['event'])
  },
  async created() {
    if (!this.adding) {
      this.workout = await HeatWorkoutApi.get(this.$route.params.workoutid)
      this.heats = await HeatWorkoutHeatApi.getByWorkout(
        this.$route.params.workoutid
      )
    }
    this.initialized = true
  },
  methods: {}
}
</script>
